import { ITokenRSA } from '../models/token-rsa.model';

export interface ITokenRSAConfigurations {
  tokenRSA: ITokenRSA
}

export const initialTokenRSAConfigurationsState: ITokenRSAConfigurations = {
  tokenRSA: null
};
